import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot", "submit", "radio"]

  connect() {
    this.updateSubmitState()
  }

  select(event) {
    this.slotTargets.forEach(slot => slot.classList.remove("appointment-slot--active"))
    event.currentTarget.closest("[data-appointment-slot-picker-target='slot']")
      ?.classList.add("appointment-slot--active")
    this.updateSubmitState()
  }

  updateSubmitState() {
    const anyChecked = this.radioTargets.some(r => r.checked)
    this.submitTarget.disabled = !anyChecked
  }
}
